import { Random } from './random';
import { ArchiveProvider } from './archive';

export { ArchiveProvider };
export type { ArchiveProvider as IArchiveProvider } from './archive';

export const supportedLanguages = ['cs', 'en'] as const;
export type LangCode = (typeof supportedLanguages)[number];

export type Lang = Record<string, string>;

export interface GenData {
  random: Random;
  archive: ArchiveProvider;
  lang: Lang;
  langCode: LangCode;
}
